module.exports = __webpack_public_path__ + "static/media/queen.20d76d4e.png";